import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'

class Status {
    list(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(
            `${APIPath.status}?${params}`,
        )
    }
}

const StatusService = new Status()
Object.freeze(StatusService)
export { StatusService }
